module.exports = __webpack_public_path__ + "static/media/06.cc3418c9.jpg";